import * as actionTypes from './constants'
import { api } from 'app/modules/eloqua/api'

export function fetchEloquaFieldsSuccess({ fields }) {
  return {
    type: actionTypes.FETCH_ELOQUA_FIELDS_SUCCESS,
    fields
  }
}

export function fetchEloquaMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.FETCH_ELOQUA_MAPPINGS_SUCCESS,
    mappings
  }
}

export function patchEloquaMappingsSuccess({ mappings }) {
  return {
    type: actionTypes.PATCH_ELOQUA_MAPPINGS_SUCCESS,
    mappings
  }
}

export function patchEloquaMappingsError(err) {
  return {
    type: actionTypes.PATCH_ELOQUA_MAPPINGS_ERROR,
    err
  }
}

export function patchEloquaMappingsStart() {
  return {
    type: actionTypes.PATCH_ELOQUA_MAPPINGS_START
  }
}

export function fetchEloquaFields() {
  return dispatch => {
    api.fetchEloquaFields().then(response => {
      dispatch(fetchEloquaFieldsSuccess(response))
    })
  }
}

export function fetchEloquaMappings() {
  return dispatch => {
    api.fetchEloquaMappings().then(response => {
      dispatch(fetchEloquaMappingsSuccess(response))
    })
  }
}

export function patchEloquaMappings(mappings, successCB = () => { }) {
  return dispatch => {
    dispatch(patchEloquaMappingsStart())
    api.patchEloquaMappings(mappings)
            .then(response => {
              successCB()
              dispatch(patchEloquaMappingsSuccess(response))
            })
            .catch(err => {
              dispatch(patchEloquaMappingsError(err))
            })
  }
}


// WEBPACK FOOTER //
// ./src/scripts/app/modules/eloqua/actions.js